import { useEffect } from "react";

import { hexToRgb } from "@nens/shared-utils";

import { TwoDWaterflowProps } from "./two-d-waterflow";
import { BasicInfo, WindowWind } from "./types";

interface UseConfigHooksProps extends TwoDWaterflowProps {
  setHideCanvasses: (hide: boolean) => void;
  redrawCanvas: () => void;
  basicInfo: BasicInfo;
}

let savedMinVelocity: number | null = null;

// Here is where we update the configuration of the 2D flow. Only needs to redraw if the min velocity changes
export const useConfigHooks = ({
  config,
  redrawCanvas,
  setHideCanvasses,
  basicInfo,
}: UseConfigHooksProps) => {
  useEffect(() => {
    const windWindow = window as WindowWind;
    const wind1 = windWindow.wind1;
    const wind2 = windWindow.wind2;

    if (config && wind1 && wind2) {
      const newColor: [number, number, number, number] = [...hexToRgb(config.color), 1];
      wind1.particleColors = newColor;
      wind2.particleColors = newColor;

      const newAmount = (7000 * config.amountPercentage) / 50;
      wind1.numParticles = newAmount;
      wind2.numParticles = newAmount;

      const newSpeed = (0.2 * config.speedPercentage) / 50;
      wind1.speedFactor = newSpeed;
      wind2.speedFactor = newSpeed;

      const newSize = (3 * config.sizePercentage) / 50;
      wind1.particleSize = newSize;
      wind2.particleSize = newSize;

      if (savedMinVelocity !== null && savedMinVelocity !== config.waterflowThreshold)
        redrawCanvas();
      savedMinVelocity = config.waterflowThreshold;

      setHideCanvasses(!config.visible);
    }
  }, [config, basicInfo]);
};
